import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAnalysisHandler = (
  isLoggedIn,
  loading,
  analyzeLoading,
  handleAnalyze,
  setLoginDialogOpen
) => {
  const navigate = useNavigate();
  
  // 로그인 후 자동 분석을 위한 상태
  const [pendingAnalysis, setPendingAnalysis] = useState(false);

  // 로그인 후 자동 분석 처리
  useEffect(() => {
    if (isLoggedIn && pendingAnalysis) {
      handleAnalyze().then((result) => {
        if (result && result.historyId) {
          navigate(`/analyze/${result.historyId}`);
        }
      });
      setPendingAnalysis(false);
    }
  }, [isLoggedIn, pendingAnalysis, handleAnalyze, navigate]);

  const handleAnalyzeClick = async () => {
    // ✅ 중복 클릭 방지
    if (loading || analyzeLoading) {
      console.log('🚫 [useAnalysisHandler] 이미 분석 중이므로 클릭 무시');
      return;
    }

    if (!isLoggedIn) {
      setPendingAnalysis(true);
      setLoginDialogOpen(true);
      return;
    }

    const result = await handleAnalyze();
    if (result && result.historyId) {
      // ✅ 페이지 이동 시에도 스피닝 로더 유지 (약간의 지연 후 이동)
      setTimeout(() => {
        // 광역 복사인 경우 쿼리 파라미터와 함께 이동
        if (result.copiedFromGlobal) {
          const videoTitle = encodeURIComponent(result.videoTitle || '');
          navigate(`/analyze/${result.historyId}?globalCopy=true&videoTitle=${videoTitle}`);
        } else if (result.existingHistory) {
          // 기존 히스토리인 경우 쿼리 파라미터와 함께 이동
          const videoTitle = encodeURIComponent(result.videoTitle || '');
          navigate(`/analyze/${result.historyId}?existingHistory=true&videoTitle=${videoTitle}`);
        } else {
          // 일반 분석인 경우 바로 이동
          navigate(`/analyze/${result.historyId}`);
        }
      }, 300); // 300ms 후 페이지 이동 (스피닝 로더가 보이도록)
    }
  };

  return {
    pendingAnalysis,
    setPendingAnalysis,
    handleAnalyzeClick
  };
}; 